import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/logo/logo.png';

const Footer = () => {
  return (
    <footer className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl shadow-2xl border-t border-gray-200 dark:border-gray-800">
      <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
        {/* Top Section: Logo + Links */}
        <div className="sm:flex sm:items-start sm:justify-between mb-6">
          {/* Logo */}
          <div className="flex flex-col items-center sm:items-start animate-fadeInUp">
            {/* Logo + Company Name in Row */}
            <div className="flex items-center mb-4 space-x-3 rtl:space-x-reverse group">
              <img
                src={Logo}
                className="h-16 w-16 transition-transform duration-300 group-hover:rotate-12"
                alt="GLabs Automator Logo"
              />
              <span className="text-2xl font-bold text-gray-900 dark:text-white transition-all duration-300">
                <span className="text-[#4285F4]">GLabs </span>
                <span className="text-[#34A853]">Automator</span>
              </span>
            </div>

            {/* Product Hunt Badge below */}
            <div className="mt-4 animate-fade-in-up">
              <a
                href="https://www.producthunt.com/products/g-labs-automator"
                target="_blank"
                rel="noreferrer"
                className="inline-block transition-transform hover:scale-105"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=955610&theme=light&t=1747588463557"
                  alt="GLabs Automator - Product Hunt"
                  className="w-[200px] max-w-full h-auto mb-4"
                />
              </a>
            </div>
          </div>

          {/* Footer Links Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 sm:gap-16 text-gray-700 dark:text-gray-300 animate-fadeInUp" style={{ animationDelay: '200ms' }}>
            {/* Quick Links */}
            <div>
              <h3 className="mb-4 font-bold text-gray-900 dark:text-white text-lg">
                Quick Links
              </h3>
              <ul className="space-y-3 text-sm">
                <li>
                  <a
                    href="#"
                    className="hover:text-[#4285F4] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    About
                  </a>
                </li>
                <li>
                  <Link
                    to="/privacy-policy"
                    className="hover:text-[#4285F4] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms-of-service"
                    className="hover:text-[#4285F4] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <a
                    href="https://intercom.help/connectautoplaylabs/en"
                    className="hover:text-[#4285F4] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Features / Sections */}
            <div>
              <h3 className="mb-4 font-bold text-gray-900 dark:text-white text-lg">
                Sections
              </h3>
              <ul className="space-y-3 text-sm">
                <li>
                  <a
                    href="#features"
                    className="hover:text-[#34A853] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    Features
                  </a>
                </li>
                <li>
                  <a
                    href="#how-it-works"
                    className="hover:text-[#34A853] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    How It Works
                  </a>
                </li>
                <li>
                  <a
                    href="#faq"
                    className="hover:text-[#34A853] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    FAQ
                  </a>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h3 className="mb-4 font-bold text-gray-900 dark:text-white text-lg">
                Support
              </h3>
              <ul className="space-y-3 text-sm">
                <li>
                  <a
                    href="#cta"
                    className="hover:text-[#EA4335] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    Get Started
                  </a>
                </li>
                <li>
                  <a
                    href="https://intercom.help/connectautoplaylabs/en"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-[#EA4335] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    Help Center
                  </a>
                </li>
                <li>
                  <a
                    href="#how-it-works"
                    className="hover:text-[#EA4335] transition-all duration-300 inline-block transform hover:translate-x-1"
                  >
                    Tutorials
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="my-6 border-gray-300 sm:mx-auto dark:border-gray-700 lg:my-8" />

        {/* Bottom Section: Copyright */}
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center animate-fadeInUp" style={{ animationDelay: '400ms' }}>
          <span className="text-sm text-gray-600 dark:text-gray-400 font-medium">
            © {new Date().getFullYear()}{' '}
            <a
              href="https://oxymai.com/"
              className="hover:text-[#4285F4] transition-all duration-300 inline-block"
              target="_blank"
              rel="noreferrer"
            >
              Oxymai
            </a>
            . All Rights Reserved.
          </span>

          <ul className="flex mt-3 sm:mt-0 space-x-6 text-gray-600 dark:text-gray-400 text-sm font-medium">
            <li>
              <a
                href="#top"
                className="hover:text-[#4285F4] transition-all duration-300 inline-block"
              >
                Back to top
              </a>
            </li>
            <li>
              <a
                href="#features"
                className="hover:text-[#34A853] transition-all duration-300 inline-block"
              >
                Features
              </a>
            </li>
            <li>
              <a
                href="#faq"
                className="hover:text-[#EA4335] transition-all duration-300 inline-block"
              >
                FAQ
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
